function injectStyle (ssrContext) {
  require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2b95c41f\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"includePaths\":[\"/Users/noomz/Projects/Opendream/kadnud/kadnud-tcfe-app/src/css\"],\"sourceMap\":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ForgotPassword.vue")
}
var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ForgotPassword.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2b95c41f\",\"hasScoped\":true}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ForgotPassword.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b95c41f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ForgotPassword.vue
// module id = 1061
// module chunks = 0